$(document).on('click','.product-options--option label[data-option-name="color"]',function(e) {
  color_grouping();
})

$('.ctm_slider .ctm_carousel--container').slick({
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1
  });

 
color_grouping();

 function color_grouping(){
  var color = 'color_'+$('.product-options--option label[data-option-name="color"] :radio:checked').val().toLowerCase().replaceAll('  ',' ').replaceAll(' ','-');
  var len =  $('.main-product--desktop .product-media--variants .product-media--root[data-alt="'+color+'"]').length;
  $('.main-product--desktop').css('opacity', 0);
   if(len > 0){
      $('.main-product--desktop .product-media--variants .product-media--root[data-alt="'+color+'"]').each(function(i,e){
       if(i == 0){
        $(this).attr('data-active',true);    
       }
     })
     $('.main-product--desktop .product-media--variants .product-media--root[data-alt!="'+color+'"]').attr('data-active',false);
     $('product-thumbs-element .product-media--thumbs-wrapper .product-media--thumb[data-alt="'+color+'"]').show();
     $('product-thumbs-element .product-media--thumbs-wrapper .product-media--thumb[data-alt!="'+color+'"]').hide(); 
  
     $('.ctm_carousel--container').slick('slickUnfilter');
     $('.ctm_carousel--container').slick('slickFilter',$('.ctm_slider .ctm_carousel--block[data-alt="'+color+'"]'));
     setTimeout(function(e){
       $('product-thumbs-element .product-media--thumbs-wrapper .product-media--thumb[data-alt="'+color+'"]')[0].click();
       $('.main-product--desktop').css('opacity', 1);
     },50);
   }else{
     $('.main-product--desktop .product-media--variants .product-media--root[data-alt]').attr('data-active',false);  
     $('.main-product--desktop .product-media--variants .product-media--root[data-alt]').each(function(i,e){
       if(i == 0){
        $(this).attr('data-active',true);    
       }
     })
     $('product-thumbs-element .product-media--thumbs-wrapper .product-media--thumb[data-alt]').show();
     $('.ctm_carousel--container').slick('slickUnfilter');
     setTimeout(function(e){
       $('product-thumbs-element .product-media--thumbs-wrapper .product-media--thumb[data-alt]')[0].click();
       $('.main-product--desktop').css('opacity', 1);
     },50);
   } 
   
 }